/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILabTestCategoryGroup } from 'app/shared/model/lab-test-category-group.model';
import { ILabTestCategory } from 'app/shared/model/lab-test-category.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { IImageTests } from 'app/shared/model/image-tests.model';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';

export interface ILabTestGroupItem {
  id?: string;
  active?: boolean | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  cursor?: number;
  testType?: keyof typeof AssociationType | null;
  lcGroupItem?: ILabTestCategoryGroup | null;
  lcTestCategory?: ILabTestCategory | null;
  panel?: IDiagLabPanel | null;
  imageTest?: IImageTests | null;
}

export const defaultValue: Readonly<ILabTestGroupItem> = {
  active: false,
};
